import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { TvPlanContext } from "../../contexts/tvplancontext";
import { isObjectNotEmpty, parseStringOr } from "../../helpers/AppxUtils"
import TvService from "../TvService";

import "./index.css";


function TvPickGroup(props) {
    const ctx = useContext(TvPlanContext);
    const cfg = ctx.getTvConfig();
    const { i18n } = useTranslation('tvplan');
    const group = cfg.picks.group[props.code] || {};

    if (!isObjectNotEmpty(group)) {
        return null;
    }

    let des = parseStringOr(group.des, "Group");
    let desFr = parseStringOr(group.desFr, "");

    if (i18n.language === "fr" && desFr !== "") {
        des = desFr;
    }

    let out = [];

    for (let scode of group.services) {
        if (scode === "espnc") {
            continue;
        }

        let isServicePickGoupSelected = ctx.isServicePickGoupSelected(scode);
        let selected = ctx.isServiceSelected(scode);
        let isImplicit = ctx.isServiceImplicit(scode);
        let onClick = () => ctx.selectServiceClick(scode);

        if (!isServicePickGoupSelected) {
            if (isImplicit) {
                onClick = () => ctx.showRemoveFavDialog(scode);
            }
            else if (selected) {
                onClick = () => ctx.unselectServiceClick(scode);
            }
        }

        out.push(
            <TvService
                key={`pick-${props.code}-service-${scode}`}
                code={scode}
                onClick={onClick}
                selected={selected}
                tileSize="large"
                removeIfInStarter={true}
                pickMode={props.pickMode}
                br={(group.br)}
            />
        );
    }

    return (
        <div className="tv-pick-group">
           <div className="tv-pick-group-name">{des}</div>
           {out}
        </div>
    );
}

export default TvPickGroup;
